import React from 'react';
import { motion } from 'framer-motion';
const pills = ['🔒 Pago seguro', '⚡ Acceso en 5 minutos', '🛡️ Garantía 7 días', '📄 100% PDF'];
export function FinalCTA() {
  return <section className="bg-white py-20 px-5 text-center" data-id="element-55">
      <div className="max-w-[700px] mx-auto" data-id="element-56">
        <h2 className="font-serif text-navy mb-5 text-[clamp(1.6rem,4vw,2.6rem)]" data-id="element-57">
          Empieza hoy mismo a entender a tu bebé
        </h2>
        <p className="text-[#555] mb-10 text-[1.1rem]" data-id="element-58">
          No dejes que pase otro día de dudas y agotamiento. Toma el control de
          la crianza con el sistema paso a paso de Cherub Agency™.
        </p>

        <a href="#oferta" className="inline-block font-serif font-bold text-navy text-[1.1rem] px-12 py-5 rounded-md tracking-wide transition-all duration-200 hover:-translate-y-0.5" style={{
        background: 'linear-gradient(135deg, #f0c040 0%, #e8a820 100%)',
        boxShadow: '0 8px 32px rgba(240,192,64,0.35)'
      }} data-id="element-59">
          → QUIERO EL SISTEMA COMPLETO · 16,97€
        </a>

        <div className="mt-5 flex flex-wrap justify-center gap-5" data-id="element-60">
          {pills.map(p => <span key={p} className="text-[0.78rem] text-navy/60 font-medium" data-id="element-61">
              {p}
            </span>)}
        </div>
      </div>
    </section>;
}